// extracted by mini-css-extract-plugin
module.exports = {"container":"ThankYouPage_container__35QAw","statsText":"ThankYouPage_statsText__1L6Io","noImagestatsText":"ThankYouPage_noImagestatsText__2sSvQ"};